import React from 'react';
import { Form } from 'react-formio';

export class PrintPreview extends React.PureComponent {
  render() {
    const { title, form, options } = this.props;
    return (
      <div className="App row print">
        <div className="header">
          <div className="row">
            <div className="form-title form-title-view">{title}</div>
            <span className="dot fa fa-circle"></span>
            <span className="form-type">Form Viewer</span>
          </div>
        </div>
        <div className="form-viewer-container">
          <Form key={Date.now()} form={form} options={options}></Form>
        </div>
      </div>
    );
  }
}
export default PrintPreview;
